import React from "react";

const Main = () => {
  return (
    <div>
      <div className="p-5 max-w-fit mx-auto my-8 bg-amber-400 rounded-xl shadow-md flex items-center space-x-1 animate-bounce">
        <div className="shrink-0">
          <div className="text-5xl flex items-center text-center font-medium text-white">
            🥘🥮😋 LETS EAT ! 😋🍱🥣
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Main;
